function imgHeroHomeHeight(){
    if($('.info-banner').length){
        $('.promo__home-background-wrap').height($('.center--home-promo').outerHeight() + $('.main-header__navbar').outerHeight() + $('.info-banner').outerHeight());
    }
    else{
        $('.promo__home-background-wrap').height($('.center--home-promo').outerHeight() + $('.main-header__navbar').outerHeight());
    }

}
$(window).on('load resize orientationchange', function(){
    if ($('.touchevents').length) {
        imgHeroHomeHeight();
    }
});